import styled from 'styled-components';
import { rgba } from 'polished';

import { Box } from '../abstract';

export const Backdrop = styled(Box).attrs({
  display: { sm: 'block', md: 'none' },
})`
  position: fixed;
  content: '';
  background-color: ${rgba(0, 0, 0, 0.7)};
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99;
`;
